import {batchActions} from 'redux-batch-enhancer'
import {CALL_API} from './api'

let buffer = []

export default store => next => action => {
  const {type = ''} = action
  if (type.endsWith('LOCATION_CHANGE')) {
    buffer = []
  }
  if (action[CALL_API]) {
    // Add only last event of certain type to the buffer
    buffer = buffer.filter(bufferedAction =>
      bufferedAction[CALL_API].types[0] !== action[CALL_API].types[0]
    )
    buffer.push(action)
  }
  if (type === 'REFRESH') {
    store.dispatch(batchActions(buffer))
    return null
  }
  return next(action)
}



// WEBPACK FOOTER //
// ./client/redux/middleware/requestsBuffer.js